export default __webpack_public_path__ + "static/media/clock-blue.ad82729b.svg";